import ReportMovement from "../../components/report/report-movement";
import { ReportMovementData } from "../../models/interfaces/reports/report-movement-data";
import { useAuthState } from "../../utilities/contexts/auth-state-context";
import { Redirect } from 'react-router-dom';

const ReportMovementTestPage: React.FC = () => {
    const { state } = useAuthState();
    if (!state.claims.superAdmin) {
        return <Redirect push to="/" />;
    }

    const data: ReportMovementData = {
        // BaseReportData fields:
        groupNames: ["test", "test2", "test3"],
        organizationName: "Org Name that can be Longer",
        reportDate: "2022-05-06",
        tagNames: ["FMS Instructors"],
        totalUsers: 20,
        filterNames: ["Pain", "Mobility"],
        // ReportMovementData fields:
        focusAreas: ["mobility", "strength"],
        healthCategories: ["Health", "Wellness"],
        isInPain: true,
        users: [
            {
                dob: "1990-01-01",
                inPain: true,
                mskScore: 85,
                name: "John Doe",
                toeTouchScore: 92,
                toeTouchPain: false,
                shoulderMobilityScore: 87,
                shoulderMobilityPain: false,
                rotationScore: 88,
                rotationPain: false,
                squatScore: 80,
                squatPain: false,
                balanceScore: 90,
                balancePain: false,
                shoulderClearing: true,
                spineClearing: true,
                movementScore: 85,
                movementFocus: "mobility"
            },
            {
                dob: "1985-05-12",
                inPain: true,
                mskScore: 78,
                name: "Jane Smith",
                toeTouchScore: 88,
                toeTouchPain: true,
                shoulderMobilityScore: 82,
                shoulderMobilityPain: true,
                rotationScore: 80,
                rotationPain: true,
                squatScore: 75,
                squatPain: true,
                balanceScore: 85,
                balancePain: true,
                shoulderClearing: false,
                spineClearing: true,
                movementScore: 78,
                movementFocus: "strength"
            }
        ]
    }

    return <ReportMovement data={data} />;
}

export default ReportMovementTestPage;
